<template>
  <v-input :rules="rules" :error.sync="error">
    <v-layout row>
      <v-flex xs4>
        <v-autocomplete
          :readonly="readonly"
          :error="error"
          v-model="hora"
          @change="cambiada"
          type="number"
          :items="horas"
          class="campo"
          placeholder="HH"
          hide-details="auto"
          auto-select-first
        ></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-autocomplete
          :readonly="readonly"
          :error="error"
          v-model="minuto"
          @change="cambiada"
          type="number"
          :items="minutos"
          class="campo"
          placeholder="MM"
          hide-details="auto"
          auto-select-first
        ></v-autocomplete>
      </v-flex>
    </v-layout>
  </v-input>
</template>

<script>
export default {
  name: 'timepicker',
  props: ['readonly', 'allowedMinutes', 'value', 'rules'],
  data() {
    return {
      modal: false,
      time: null,
      hora: null,
      minuto: null,
      error: null,
    };
  },
  created() {
    this.time = this.value;
  },
  methods: {
    cambiada() {
      if (this.minuto && this.hora) {
        this.time = `${this.hora}:${this.minuto}`;
      } else {
        this.time = null;
      }
    },
  },
  watch: {
    time() {
      this.$emit('input', this.time);
    },
    value() {
      this.time = this.value;
      if (this.time) {
        const parts = this.time.split(':');
        this.hora = this.horas.find((h) => h === parts[0]);
        this.minuto = this.minutos.find((m) => m === parts[1]);
      }
    },
  },
  computed: {
    horas() {
      const res = [];
      for (var i = 0; i <= 23; i++) {
        res.push(i < 10 ? `0${i}` : String(i));
      }
      return res;
    },
    minutos() {
      const res = [];
      for (var i = 0; i <= 59; i++) {
        res.push(i < 10 ? `0${i}` : String(i));
      }
      return res;
    },
  },
};
</script>

<style scoped>
.campo {
  margin-right: 15px;
  width: 150px;
}
.contenedor {
  display: flex;
}
</style>
